<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2023-11-01 09:43:39
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2023-12-04 22:03:51
 * @FilePath: \minipro-manger\src\views\WeatherAlert\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE   
-->
<template>
  <div>
    <el-card class="box-card" style="height:850px">
      <div slot="header">
        <div class="headerCardBox">
          <div style="width:500px;  display: flex;  align-items: center;">
            <div style="margin-left:50px;width:120px">发布时间：</div>
            <div>
              <el-select v-model="AreaName" placeholder="请选择">
                <el-option
                  v-for="item in textList"
                  :key="item.AreaName"
                  :label="item.AreaName"
                  :value="item.Area"
                ></el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="seachBtn">
          <el-button type="primary" @click="getTableData">搜索</el-button>
          <el-button type="primary">重置</el-button>
        </div>
      </div>
      <div>
        <div class="adddBtnBox">
          <el-button type="primary" @click="addNewData">添加</el-button>
        </div>
        <el-table :data="tableData" style="width: 100%" :border="true" height="600" stripe>
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column prop="farmName" label="农场名" width="180"></el-table-column>

          <el-table-column prop="landArea" label="面积"></el-table-column>
          <el-table-column prop="paddyArea" label="种植面积"></el-table-column>
          <el-table-column prop="lon" label="经度"></el-table-column>
          <el-table-column prop="lat" label="纬度"></el-table-column>
          <el-table-column prop="town" label="区域"></el-table-column>

          <el-table-column prop="address" label="操作" width="200">
            <template slot-scope="scope">
              <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
              <el-button size="mini" type="danger" @click="handleDelete( scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="10"
        :total="dataList.length"
        @current-change="pageChange"
      ></el-pagination>
      <el-dialog title="新增信息" :visible.sync="addIshowPop" width="30%">
        <div style="  display: flex;
  align-items: center;">
          <div style="width:100px;text-align:left">区域：</div>
          <el-select v-model="addtown" clearable placeholder="请选择">
            <el-option
              v-for="item in textList"
              :key="item.AreaName"
              :label="item.AreaName"
              :value="item.Area"
            ></el-option>
          </el-select>
        </div>
        <div style="  display: flex;
  align-items: center;margin-top:15px">
          <div style="width:100px;text-align:left">农场名：</div>
          <el-input placeholder="请输入内容" v-model="addfarmName"></el-input>
        </div>
        <div style="  display: flex;
  align-items: center;margin-top:15px">
          <div style="width:100px;text-align:left">面积：</div>
          <el-input placeholder="请输入内容" v-model="addlandArea"></el-input>
        </div>
        <div style="  display: flex;
  align-items: center;margin-top:15px">
          <div style="width:100px;text-align:left">种植面积：</div>
          <el-input placeholder="请输入内容" v-model="addpaddyArea"></el-input>
        </div>
        <div style="  display: flex;
  align-items: center;margin-top:15px">
          <div style="width:100px;text-align:left">经度：</div>
          <el-input placeholder="请输入内容" v-model="addlon"></el-input>
        </div>
        <div style="  display: flex;
  align-items: center;margin-top:15px">
          <div style="width:100px;text-align:left">纬度：</div>
          <el-input placeholder="请输入内容" v-model="addlat"></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addIshowPop = false">取 消</el-button>
          <el-button type="primary" @click="submitNewData">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="修改信息" :visible.sync="editIshowPop" width="30%">
        <div style="  display: flex;
  align-items: center;">
          <div style="width:100px;text-align:left">区域：</div>
          <el-select v-model="editFromData.town" clearable placeholder="请选择">
            <el-option
              v-for="item in textList"
              :key="item.AreaName"
              :label="item.AreaName"
              :value="item.Area"
            ></el-option>
          </el-select>
        </div>
        <div style="  display: flex;
  align-items: center;margin-top:15px">
          <div style="width:100px;text-align:left">农场名：</div>
          <el-input placeholder="请输入内容" v-model="editFromData.farmName"></el-input>
        </div>
        <div style="  display: flex;
  align-items: center;margin-top:15px">
          <div style="width:100px;text-align:left">面积：</div>
          <el-input placeholder="请输入内容" v-model="editFromData.landArea"></el-input>
        </div>
        <div style="  display: flex;
  align-items: center;margin-top:15px">
          <div style="width:100px;text-align:left">种植面积：</div>
          <el-input placeholder="请输入内容" v-model="editFromData.paddyArea"></el-input>
        </div>
        <div style="  display: flex;
  align-items: center;margin-top:15px">
          <div style="width:100px;text-align:left">经度：</div>
          <el-input placeholder="请输入内容" v-model="editFromData.lon"></el-input>
        </div>
        <div style="  display: flex;
  align-items: center;margin-top:15px">
          <div style="width:100px;text-align:left">纬度：</div>
          <el-input placeholder="请输入内容" v-model="editFromData.lat"></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editIshowPop = false">取 消</el-button>
          <el-button type="primary" @click="submitEdit">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import textList from "./textList.json";
export default {
  data() {
    return {
      input1: "",
      tableData: [],
      textList: [],
      AreaName: "全部",
      dataList: [],
      addIshowPop: false,
      editIshowPop: false,
      ChoosePage: 1,
      addfarmName: "",
      addlandArea: "",
      addlon: "",
      addlat: "",
      addpaddyArea: "",
      addtown: "",

      editFromData: {
        farmName: "",
        landArea: "",
        lon: "",
        lat: "",
        paddyArea: "",
        town: "",
        paddyArea: ""
      },
      editId: ""
    };
  },
  created() {
    this.getTableData();
    this.textList = textList.data;
  },
  methods: {
    handleDelete(data) {
      this.axios({
        method: "post",
        url: "https://www.moodsci.com/chongzhou/agroData/deletePaddyInfo",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: {
          id: data.id
        }
      }).then(res => {
        this.getTableData();
        this.$message({
          message: "删除成功",
          type: "success"
        });
        // this.editIshowPop = false;
      });
    },
    handleEdit(e) {
      this.editIshowPop = true;
      // console.log(e);
      this.editFromData = e;
      this.editId = e.id;
    },
    submitEdit() {
      // console.log(this.editFromData);
      this.axios({
        method: "post",
        url: "https://www.moodsci.com/chongzhou/agroData/modifyPaddyInfo",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: {
          town: this.editFromData.town,
          farmName: this.editFromData.farmName,
          landArea: this.editFromData.landArea,
          paddyArea: this.editFromData.paddyArea,
          lon: this.editFromData.lon,
          lat: this.editFromData.lat,
          id: this.editId
        }
      }).then(res => {
        this.getTableData();
        this.$message({
          message: "修改成功",
          type: "success"
        });
        this.editIshowPop = false;
      });
    },
    submitNewData() {
      this.axios({
        method: "post",
        url: "https://www.moodsci.com/chongzhou/agroData/addPaddyInfo",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: {
          town: this.addtown,

          farmName: this.addfarmName,
          landArea: this.addlandArea,
          paddyArea: this.addpaddyArea,
          lon: this.addlon,
          lat: this.addlat
        }
      }).then(res => {
        console.log(res);
        this.$message({
          message: "添加成功",
          type: "success"
        });
        this.getTableData();
        this.addIshowPop = false;
      });
    },
    pageChange(e) {
      this.ChoosePage = e;
      this.tableData = this.dataList.slice((e - 1) * 10, e * 10);
    },
    addNewData() {
      this.addIshowPop = true;
    },
    getTableData() {
      let town = "null";
      if (this.AreaName != "全部") {
        town = this.AreaName;
      }
      this.axios({
        method: "post",
        url: "https://www.moodsci.com/chongzhou/agroData/getPaddyInfo",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: {
          town: town,
          farmName: "null"
        }
      }).then(res => {
        console.log(res.data);
        this.dataList = res.data;
        this.tableData = res.data.slice(
          (this.ChoosePage - 1) * 10,
          this.ChoosePage * 10
        );
      });
    }
  }
};
</script>

<style>
.headerCardBox {
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
}
.seachBtn {
  display: flex;
  justify-content: end;
  margin-top: 15px;
}
.adddBtnBox {
  height: 50px;
  float: right;
}
</style>